import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      marginTop: SMALL_MARGIN,
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.down('md')]: {
        marginTop: 24,
        marginBottom: 48,
      },
    },
    title: {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    btn: {
      fontSize: 16,
      [theme.breakpoints.up('md')]: {
        marginTop: 8,
      },
    },
    removeIcon: {
      width: 20,
      height: 20,
      paddingTop: 4,
    },
  }),
);

export default useStyles;
